import React from "react";
import GreenCheck from "../svg/green-check";
import ErrorIcon from "../svg/error";

interface ThankYouModalProps {
    title: string;
    text: string;
    type?: string;
}

const ThankYouModal: React.FC<ThankYouModalProps> = ({ title, text, type = "success" }) => {
    return (
        <div className="w-[446px] h-[260px] text-center bg-white rounded-[40px] p-[48px] max-[576px]:rounded-[20px] max-[576px]:w-[328px] max-[576px]:h-[auto] max-[576px]:p-[20px]">
            <div className="flex justify-center">
                {type === "error" ? <ErrorIcon /> : <GreenCheck />}
            </div>
            <div className="mt-2">
                <p className="font-bold text-[32px] text-black-50 max-[576px]:mt-[8px] max-[576px]:text-[24px]">{title}</p>
                <p className="mt-2 text-gray-800 text-lg leading-[21.6px] max-[576px]:mt-[8px] max-[576px]:text-[14px]">{text}</p>
            </div>
        </div>
    );
};

export default ThankYouModal;
